// extracted by mini-css-extract-plugin
export default {"para":"About_para__R3+zG","child2":"About_child2__3l+li"};